////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const myAccount = {
	getAccount: () => ({
		type: ActionsTypes.GET_ACCOUNT,
		payload: {},
	}),
	getAccountSuccess: (user) => ({
		type: ActionsTypes.GET_ACCOUNT_SUCCESS,
		payload: {
			user,
		},
	}),
	getAccountFailure: (error) => ({
		type: ActionsTypes.GET_ACCOUNT_FAILURE,
		payload: {
			error,
		},
	}),

	updateAccount: (myAccount) => ({
		type: ActionsTypes.UPDATE_MY_ACCOUNT,
		payload: {
			myAccount,
		},
	}),
	updateAccountSuccess: (user) => ({
		type: ActionsTypes.UPDATE_MY_ACCOUNT_SUCCESS,
		payload: {
			user,
		},
	}),
	updateAccountFailure: (error) => ({
		type: ActionsTypes.UPDATE_MY_ACCOUNT_FAILURE,
		payload: {
			error,
		},
	}),
}

export default myAccount
